import React from 'react';

import { getRiskBadgeClass, getRiskBadgeStyle, getRiskLabel } from './phiAuditUtils';

const PHIAuditPageFindings = ({ flaggedPages }) => {
  return (
    <div className="mb-3">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <div>
          <h6 className="fw-semibold mb-1">Public Pages With Potential PHI Exposure</h6>

          <div className="text-muted small">
            Public pages connected to collections containing PHI.
          </div>
        </div>

        <span className="badge bg-danger">{flaggedPages.length}</span>
      </div>

      <div className="border rounded overflow-hidden">
        {flaggedPages.map((page, pageIndex) => {
          if (!page || typeof page !== 'object') {
            return null;
          }

          const pageUuid = page.pageUuid || `page-${pageIndex}`;

          const pageName = page.pageName || 'Unnamed Page';

          const pageSlug = page.pageSlug || '';

          const risk = page.risk || 'medium';

          const reason =
            page.reason || 'Potential PHI exposure detected based on the supplied metadata.';

          const exposedPhiFields = Array.isArray(page.exposedPhiFields)
            ? page.exposedPhiFields
            : [];

          return (
            <div key={pageUuid} className="p-3 border-bottom">
              <div className="d-flex justify-content-between align-items-start">
                <div className="pe-3">
                  <div className="fw-medium">{pageName}</div>

                  {pageSlug && <small className="text-muted d-block">/{pageSlug}</small>}

                  <div className="text-muted small mt-1">{reason}</div>

                  {exposedPhiFields.length > 0 && (
                    <div className="mt-2">
                      {exposedPhiFields.map((field, fieldIndex) => (
                        <span
                          key={`${String(field)}-${fieldIndex}`}
                          className="badge bg-light text-dark border mr-1 mb-1"
                        >
                          {field}
                        </span>
                      ))}
                    </div>
                  )}
                </div>

                <span
                  className={getRiskBadgeClass(risk)}
                  style={{
                    ...getRiskBadgeStyle(risk),
                    padding: '5px 10px',
                    fontSize: '10px',
                    fontWeight: 600,
                    borderRadius: '999px',
                    display: 'inline-block',
                    lineHeight: 1,
                    color: String(risk).toLowerCase() === 'medium' ? '#212529' : '#fff',
                  }}
                >
                  {getRiskLabel(risk)}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PHIAuditPageFindings;
